// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"53b06955","222":"558c0a67","771":"e4ba3729","880":"240dd64f"}[chunkId] + ".chunk.css";
};